import StatusBadge from "../../components/common/StatusBadge";

const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "User",
    dataIndex: "userDetails",
    render: defaultRender,
  },
  {
    title: "File Name",
    dataIndex: "fileName",
    render: defaultRender,
  },
  {
    title: "File No.",
    dataIndex: "fileNumber",
    render: defaultRender,
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    render: defaultRender,
  },
  {
    title: "Source",
    dataIndex: "sign_source",
    render: (value) => (value ? <StatusBadge status={value} /> : "--"),
  },
  {
    title: "Status",
    dataIndex: "statusText",
    render: defaultRender,
  },

  {
    title: "Action",
    dataIndex: "action",
  },
];

export default columns;
